import '../scss/app.scss'
//import { tns } from "../../blankeneserhospiz/node_modules/tiny-slider"
import GLightbox from 'glightbox';
import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';
//import 'swiper/css';
//import 'swiper/css/pagination';
//import 'swiper/css/effect-fade';

(() => {
    const
        initProject = () => {
            console.log("INIT PROJECT");
        },

        initToggleMainMenu = () => {
            console.log("initToggleMainMenu");
            const
                menuOpen = document.querySelector('.main-navigation-open'),
                menuClose = document.querySelector('.main-navigation-close'),
                mainNavigation = document.querySelector('.mainnavigation'),
                body = document.querySelector('body')
            ;

            /************************************************************/
            /* open and close menu                                      */
            /************************************************************/
            menuOpen.addEventListener('click', function(e){
                e.preventDefault();
                mainNavigation.classList.toggle('active');
                body.classList.toggle('noscroll');
               setTimeout(() => {
                   menuClose.classList.toggle('active');
                }, 700);
            });

            menuClose.addEventListener('click', function(e){
                e.preventDefault();
                mainNavigation.classList.toggle('active');
                menuClose.classList.toggle('active');
                body.classList.toggle('noscroll');
            });

        },

        initScrollHeader = () => {

            console.log("initScrollHeader");

            const body = document.body;
            const scrollUp = "scroll-up";
            const scrollDown = "scroll-down";
            let lastScroll = 0;

            window.addEventListener("scroll", () => {
                const currentScroll = scrollY;
                if (currentScroll <= 0) {
                    body.classList.remove(scrollUp);
                    return;
                }

                if (currentScroll > lastScroll && !body.classList.contains(scrollDown) && currentScroll >  40) {
                    // down
                    // console.log("scroll down");
                    body.classList.remove(scrollUp);
                    body.classList.add(scrollDown);
                } else if (
                    currentScroll < lastScroll &&
                    body.classList.contains(scrollDown)
                ) {
                    // up
                    // console.log("scroll up");
                    body.classList.remove(scrollDown);
                    body.classList.add(scrollUp);
                }
                lastScroll = currentScroll;
            });
        },
        initStage = () => {
            const stageEl = document.querySelector('.swiper');
            if(!stageEl){
                return;
            }
            console.log("initStage");

            const swiper = new Swiper('.swiper', {
                // Optional parameters
                direction: 'horizontal',
                rewind: true,
                modules: [Pagination, Autoplay, EffectFade],
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },

                // If we need pagination
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },

                autoplay: {
                    delay: 6000,
                    disableOnInteraction: true,
                },
            });

            stageEl.addEventListener('mouseenter', () => swiper.autoplay.stop());
            stageEl.addEventListener('mouseleave', () => swiper.autoplay.start());

        },

        initLightbox = () => {
            console.log("initLightbox");

            // Alle Elemente mit Klassen die mit 'glightbox' beginnen finden
            const lightboxElements = document.querySelectorAll('[class*="glightbox"]');
            const selectors = new Set();

            lightboxElements.forEach(el => {
                el.classList.forEach(className => {
                    if (className.startsWith('glightbox')) {
                        selectors.add(className);
                    }
                });
            });

            // Für jeden gefundenen Selektor eine separate Lightbox initialisieren
            selectors.forEach(selector => {
                GLightbox({
                    selector: `.${selector}`
                });
            });
        },

        initFaq = () => {
            console.log("initFaq");

            const faqQuestions = document.querySelectorAll('.rsce-faq .faq .question');

            faqQuestions.forEach(question => {
                question.addEventListener('click', () => {
                    const faqItem = question.closest('.faq');
                    const isActive = faqItem.classList.contains('active');

                    // Alle FAQs schließen
                    document.querySelectorAll('.rsce-faq .faq').forEach(faq => {
                        faq.classList.remove('active');
                    });

                    // Wenn nicht aktiv war, öffnen
                    if (!isActive) {
                        faqItem.classList.add('active');
                    }
                });
            });
        },

        initDownloads = () => {
            console.log("initDownloads");
        },

        initScrollTop = () => {
            console.log("initScrollTop");

            const topButton = document.querySelector('.top');
            if (!topButton) {
                return;
            }

            topButton.addEventListener('click', (e) => {
                e.preventDefault();
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        }

        initProject()
        initToggleMainMenu()
        initScrollHeader()
        initStage()
        initLightbox()
        initFaq()
        initDownloads()
        initScrollTop()
    ;
})()

